/**
 * 가이드(NoticeCard) 메시지 다국어 지원 (guideMessages)
 *
 * 사용법:
 * import { getGuideMessage } from '@src/shared/constants/guideMessages';
 * content={getGuideMessage('ONBOARD_1_CONTENT')}
 */

import type { LocalizedMessages } from '../dto/EntityRepository';
import { useLanguageStore, Language } from '../store/languageStore';

export type GuideMessageKey =
  // Landing
  | 'LANDING_SEARCH_ARCHIVES'
  | 'LANDING_ACCESS_ARCHIVE'
  // Onboard
  | 'ONBOARD_MENU_HIDDEN'
  | 'ONBOARD_MODE_CHANGE'
  // Common
  | 'SKIP_GUIDE';

const guideMessages: LocalizedMessages<GuideMessageKey> = {
  LANDING_SEARCH_ARCHIVES: {
    [Language.EN]: "Search other archives",
    [Language.KR]: "다른 Archive를 검색해 보세요.",
  },
  LANDING_ACCESS_ARCHIVE: {
    [Language.EN]: "Access your Archive",
    [Language.KR]: "나의 Archive로 이동할 수 있어요.",
  },
  ONBOARD_MENU_HIDDEN: {
    [Language.EN]: "Tap this icon to open the sidebar.",
    [Language.KR]: "해당 버튼을 누르면 사이드 메뉴가 열립니다.",
  },
  ONBOARD_MODE_CHANGE: {
    [Language.EN]: "Switch to edit mode",
    [Language.KR]: "아래의 버튼을 누르면 편집할 수 있어요.",
  },
  SKIP_GUIDE: {
    [Language.EN]: "Click to skip =>",
    [Language.KR]: "건너뛰기 =>",
  },
};

/**
 * 가이드 메시지를 가져오는 함수
 * 언어는 languageStore에서 자동으로 가져옵니다.
 */
export function getGuideMessage(
  key: GuideMessageKey,
  params?: Record<string, string | number>
): string {
  const language = useLanguageStore.getState().language;
  const message = guideMessages[key];

  if (!message) {
    console.warn(`Guide message key "${key}" not found.`);
    return key;
  }

  let translatedMessage = message[language] || message[Language.EN];

  if (params) {
    Object.entries(params).forEach(([paramKey, paramValue]) => {
      translatedMessage = translatedMessage.replace(
        new RegExp(`\\{${paramKey}\\}`, 'g'),
        String(paramValue)
      );
    });
  }

  return translatedMessage;
}
